export const APP_BUILD_VERSION = '1.0.1';
